export const ugColleges = [
  
  {
    sno: 1,
    jnbId: "16598",
    name: "PSC & KVSC Govt. Degree College",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9490602116",
    email: "ndlg2.jkc@gmail.com"
  },
  {
    sno: 2,
    jnbId: "12558",
    name: "Govt. Degree College",
    place: "Alur",
    district: "Kurnool",
    phone: "9885096890",
    email: "alur.jkc@gmail.com"
  },
  {
    sno: 3,
    jnbId: "12560",
    name: "Govt. Degree College",
    place: "Atmakur",
    district: "Nandyal",
    phone: "9908695216",
    email: "atmakurknl.gdc@gmail.com"
  },
  {
    sno: 4,
    jnbId: "12561",
    name: "Govt. Degree College",
    place: "Banaganapalli",
    district: "Nandyal",
    phone: "9059387823",
    email: "gdcb.jkc@gmail.com"
  },
  {
    sno: 5,
    jnbId: "12562",
    name: "GVRS Govt. Degree College",
    place: "Dhone",
    district: "Nandyal",
    phone: "9440047067",
    email: "dhone.jkc@gmail.com"
  },
  {
    sno: 6,
    jnbId: "20199",
    name: "SVB Govt. Degree College",
    place: "Koilakuntla",
    district: "Nandyal",
    phone: "9490602116",
    email: "kklg4.jkc@gmail.com"
  },
  {
    sno: 7,
    jnbId: "12567",
    name: "Govt. Degree College",
    place: "Nandikotkur",
    district: "Nandyal",
    phone: "9393826020",
    email: "ndkgdc.jkc@gmail.com"
  },
  {
    sno: 8,
    jnbId: "12569",
    name: "Govt. Degree College",
    place: "Pathikonda",
    district: "Kurnool",
    phone: "8330936520",
    email: "pattikondagdc.jkc@gmail.com"
  },
  {
    sno: 9,
    jnbId: "12571",
    name: "Govt. Degree College",
    place: "Srisailam",
    district: "Nandyal",
    phone: "9493361354",
    email: "srisailam.jkc@gmail.com"
  },
  {
    sno: 10,
    jnbId: "18056",
    name: "SML Govt. Degree College",
    place: "Yemmiganur",
    district: "Kurnool",
    phone: "9701726027",
    email: "yemmiganur.gdc@gmail.com"
  },
  {
    sno: 11,
    jnbId: "12320",
    name: "SGTRM Govt. Degree College",
    place: "Yerraguntla",
    district: "Nandyal",
    phone: "9347291971",
    email: "yerraguntlagdc@gmail.com"
  },
  {
    sno: 12,
    jnbId: "33559",
    name: "Govt. Degree College",
    place: "Panyam",
    district: "Nandyal",
    phone: "9160044786",
    email: "gdcpanyam@gmail.com"
  },
  {
    sno: 13,
    jnbId: "33202",
    name: "Govt. Degree College",
    place: "Allagadda",
    district: "Nandyal",
    phone: "9866041775",
    email: "gdcallagadda@gmail.com"
  },
  {
    sno: 14,
    jnbId: "33948",
    name: "Govt. Degree College",
    place: "Adoni",
    district: "Kurnool",
    phone: "9866041775",
    email: "adonigdc@gmail.com"
  },

  {
    sno: 1,
    jnbId: "17533",
    name: "SBSYM Degree College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9491408788",
    email: "sbsymdc@gmail.com"
  },
  {
    sno: 2,
    jnbId: "20045",
    name: "STBC College",
    place: "Kurnool",
    district: "Kurnool",
    phone: "9985691775",
    email: "stbc.kurnool@gmail.com"
  },
  {
    sno: 3,
    jnbId: "10174",
    name: "The Adoni Arts & Science College",
    place: "Adoni",
    district: "Kurnool",
    phone: "9849057392",
    email: "adonicollege@gmail.com"
  },
  {
    sno: 4,
    jnbId: "17455",
    name: "SARM Degree College",
    place: "Allagadda",
    district: "Nandyal",
    phone: "9441360718",
    email: "ramalingareddypg@gmail.com"
  },
  {
    sno: 1,
    jnbId: "18880",
    name: "Sri Ramakrishna Degree College (A)",
    place: "Nandyal",
    district: "Nandyal",
    phone: "9866041775",
    email: "drgrkreddy@gmail.com"
  },
  {
    sno: 2,
    jnbId: "16141",
    name: "Osmania College (Men) (A)",
    place: "Kurnool",
    district: "Kurnool",
    phone: "7901022206",
    email: "principalock@gmail.com"
  },


    {
        sno: 1,
        jnbId: "19519",
        name: "Sri Vijayadurga Degree College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9030628410",
        email: "drpsnb@gmail.com"
    },
    {
        sno: 2,
        jnbId: "19100",
        name: "Sri Sankara's Degree College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9848603082",
        email: "sankarasug@gmail.com"
    },
    {
        sno: 3,
        jnbId: "18100",
        name: "Smt. Theresa Arts & Science College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "7330666765",
        email: "stasdc.knl@gmail.com"
    },
    {
        sno: 4,
        jnbId: "19792",
        name: "St. Joseph's Degree College, Sunkesula Road",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9247384699",
        email: "sjcknl@yahoo.com"
    },
    {
        sno: 5,
        jnbId: "31745",
        name: "BVR Degree College",
        place: "Gadivemula",
        district: "Nandyal",
        phone: "9440826430",
        email: "bvrdc2018@gmail.com"
    },
    {
        sno: 6,
        jnbId: "16872",
        name: "Ravindra Degree College for Women",
        place: "Kurnool",
        district: "Kurnool",
        phone: "7569691402",
        email: "principal.rdcfw@gmail.com"
    },
    {
        sno: 7,
        jnbId: "20766",
        name: "Vasavi Mahila Kalasala",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9440251604",
        email: "vasavikalasala@yahoo.com"
    },
    {
        sno: 8,
        jnbId: "18198",
        name: "SPY Reddy Degree College for Women",
        place: "Nandyal",
        district: "Nandyal",
        phone: "8520831532",
        email: "spyrdc@gmail.com"
    },
    {
        sno: 9,
        jnbId: "15822",
        name: "National Degree College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "9848121671",
        email: "nationalcollegenandyal@yahoo.co.in"
    },
    {
        sno: 10,
        jnbId: "16290",
        name: "Sri Sadhana Degree College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "9000674727",
        email: "ssdegreecollegendl@gmail.com"
    },
    {
        sno: 11,
        jnbId: "16852",
        name: "Sri Ravi Degree College",
        place: "Narsapuram",
        district: "Nandyal",
        phone: "9849148312",
        email: "sriravidegreecollege@gmail.com"
    },
    {
        sno: 12,
        jnbId: "17212",
        name: "Sai Degree College",
        place: "Adoni",
        district: "Kurnool",
        phone: "9849500134",
        email: "saidegreecollege026adoni1@gmail.com"
    },
    {
        sno: 13,
        jnbId: "12005",
        name: "Dr. Jyothirmayi Degree College",
        place: "Adoni",
        district: "Nandyal",
        phone: "9866278735",
        email: "jyothirmayidegreecollege.adoni@gmail.com"
    },
    {
        sno: 14,
        jnbId: "19403",
        name: "S.V. Degree College",
        place: "Atmakur",
        district: "Nandyal",
        phone: "9440875363",
        email: "svdcatmakur131@gmail.com"
    },
    {
        sno: 15,
        jnbId: "14710",
        name: "K.V. Subba Reddy Degree College",
        place: "Allagadda",
        district: "Nandyal",
        phone: "9440852221",
        email: "principalkvsrdc@gmail.com"
    },
    {
        sno: 16,
        jnbId: "19404",
        name: "Sri Venkateswara Degree College",
        place: "Banaganapalli",
        district: "Nandyal",
        phone: "9440833946",
        email: "svdegreecollege034@gmail.com"
    },
    {
        sno: 17,
        jnbId: "17261",
        name: "Sai Sree Degree College",
        place: "Dhone",
        district: "Nandyal",
        phone: "7794888882",
        email: "saisreedegreecollege.dhone@gmail.com"
    },
    {
        sno: 18,
        jnbId: "17243",
        name: "Sairam Degree College",
        place: "Kodumur",
        district: "Kurnool",
        phone: "9885813068",
        email: "prcr111@gmail.com"
    },
    {
        sno: 19,
        jnbId: "17497",
        name: "Sri Sathya Sai Degree College",
        place: "Kodumur",
        district: "Kurnool",
        phone: "9030656901",
        email: "srisatyasaidegreecollege039@gmail.com"
    },
    {
        sno: 20,
        jnbId: "19564",
        name: "Sri Vivekananda Degree College",
        place: "Kodumur",
        district: "Kurnool",
        phone: "9985382414",
        email: "srivivekanandacollegekodumur@gmail.com"
    },

    {
        sno: 21,
        jnbId: "11028",
        name: "Basi Reddy Memorial Degree College",
        place: "Nandikotkur",
        district: "Nandyal",
        phone: "9494075900",
        email: "brmdcnau@yahoo.in"
    },
    {
        sno: 22,
        jnbId: "19042",
        name: "Sri Sairam Degree College",
        place: "Nandikotkur",
        district: "Nandyal",
        phone: "8519819042",
        email: "srisairamcollege.ndk@gmail.com"
    },
    {
        sno: 23,
        jnbId: "21534",
        name: "Vyshnavi Degree College",
        place: "Yemmiganur",
        district: "Kurnool",
        phone: "9885152082",
        email: "vdc.ymgr@gmail.com"
    },
    {
        sno: 24,
        jnbId: "18128",
        name: "SNR Degree College, Karivena",
        place: "Atmakur",
        district: "Nandyal",
        phone: "9849185735",
        email: "snrdegreecollege@gmail.com"
    },
    {
        sno: 25,
        jnbId: "22657",
        name: "Vyshnavi Degree College",
        place: "Dhone",
        district: "Kurnool",
        phone: "9491526147",
        email: "vyshu.dhone@gmail.com"
    },
    {
        sno: 26,
        jnbId: "23682",
        name: "A.S. Degree College",
        place: "Tugalli",
        district: "Kurnool",
        phone: "9440388991",
        email: "asdcg2016@gmail.com"
    },
    {
        sno: 27,
        jnbId: "23669",
        name: "St. Joseph's College for Women",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9441880978",
        email: "stjosephcollegeforwomen@rediffmail.com"
    },
    {
        sno: 28,
        jnbId: "23793",
        name: "Siddhartha Degree College",
        place: "Yemmiganur",
        district: "Kurnool",
        phone: "8099442442",
        email: "sleds.ygr@gmail.com"
    },
    {
        sno: 29,
        jnbId: "23959",
        name: "S.R. Degree College",
        place: "Gudur",
        district: "Kurnool",
        phone: "8499841586",
        email: "srdcgudur@gmail.com"
    },
    {
        sno: 30,
        jnbId: "23960",
        name: "K.G.R Degree College",
        place: "Banaganapalli",
        district: "Nandyal",
        phone: "9494879580",
        email: "krcr.degree@gmail.com"
    },
    {
        sno: 31,
        jnbId: "24062",
        name: "Sana Degree College",
        place: "Koilakuntla",
        district: "Nandyal",
        phone: "9550052888",
        email: "sanadegreecollege@gmail.com"
    },
    {
        sno: 32,
        jnbId: "28586",
        name: "S.L.N. Degree College",
        place: "Kolimigundla",
        district: "Nandyal",
        phone: "9632266466",
        email: "vengaiahmc5@gmail.com"
    },
    {
        sno: 33,
        jnbId: "26923",
        name: "Gnanasaraswathi Degree College",
        place: "Bethamcherla",
        district: "Nandyal",
        phone: "9848617276",
        email: "gnanasaraswathidegreecollege@gmail.com"
    },
    {
        sno: 34,
        jnbId: "28634",
        name: "Sri Vidyanikethan Degree College",
        place: "Veldurthi",
        district: "Nandyal",
        phone: "9985540335",
        email: "ramana7080@gmail.com"
    },
    {
        sno: 35,
        jnbId: "28690",
        name: "S.V. Degree College",
        place: "Peapully",
        district: "Nandyal",
        phone: "9912422679",
        email: "svdegreecollege9@gmail.com"
    },
    {
        sno: 36,
        jnbId: "29481",
        name: "Sri Venkateswara Degree College",
        place: "Aluru",
        district: "Kurnool",
        phone: "9492711746",
        email: "svdcalur@gmail.com"
    },
    {
        sno: 37,
        jnbId: "30101",
        name: "Nalanda Degree College (Hanumapuram)",
        place: "Peddakadabur",
        district: "Kurnool",
        phone: "9908368337",
        email: "nalandadegreecollegeygr@gmail.com"
    },
    {
        sno: 38,
        jnbId: "29569",
        name: "D.N. Reddy Degree College",
        place: "Pamulapadu",
        district: "Nandyal",
        phone: "9441000033",
        email: "dnreddycollege9@gmail.com"
    },
    {
        sno: 39,
        jnbId: "29413",
        name: "S.L.V Degree College",
        place: "Dhone",
        district: "Nandyal",
        phone: "9441310343",
        email: "slvdc2014@gmail.com"
    },
    {
        sno: 40,
        jnbId: "29547",
        name: "Sri Raghavendra Degree College",
        place: "Alur",
        district: "Kurnool",
        phone: "9951127413",
        email: "jviru05@gmail.com"
    },
    {
        sno: 41,
        jnbId: "29482",
        name: "Vignan Degree College",
        place: "Gonegandla",
        district: "Kurnool",
        phone: "8328289120",
        email: "chandg822@gmail.com"
    },
    {
        sno: 42,
        jnbId: "29545",
        name: "Sri Vivekananda Degree College",
        place: "Bethamcherla",
        district: "Nandyal",
        phone: "8309303930",
        email: "svdc.btc@gmail.com"
    },
    {
        sno: 43,
        jnbId: "30189",
        name: "Sri Vinayaka Degree College",
        place: "C. Belagal",
        district: "Kurnool",
        phone: "9440333883",
        email: "vinayakadcb@gmail.com"
    },
    {
        sno: 44,
        jnbId: "30229",
        name: "Bugga Rameswara Degree College",
        place: "Orvakal",
        district: "Kurnool",
        phone: "9052778429",
        email: "brmr.dc.orvakal@gmail.com"
    },
    {
        sno: 45,
        jnbId: "30130",
        name: "Prathibha Arts & Science College",
        place: "Pathikonda",
        district: "Kurnool",
        phone: "9703185930",
        email: "prathibha.pkd99@gmail.com"
    },
    {
        sno: 46,
        jnbId: "30100",
        name: "Sri Sai Krishna Degree College",
        place: "Kallur",
        district: "Kurnool",
        phone: "9885652342",
        email: "srisaikrishnadegreecollege@gmail.com"
    },
    {
        sno: 47,
        jnbId: "30099",
        name: "Sri Vidya Sai Degree College",
        place: "Maddikera",
        district: "Kurnool",
        phone: "9985960228",
        email: "kmyagnam9885@gmail.com"
    },
    {
        sno: 48,
        jnbId: "30098",
        name: "Vijay Sai Degree College",
        place: "Pathikonda",
        district: "Kurnool",
        phone: "9573352370",
        email: "ramanareddymsc17@gmail.com"
    },
    {
        sno: 49,
        jnbId: "30137",
        name: "Brundavan Degree College",
        place: "Dornipadu",
        district: "Nandyal",
        phone: "9441580669",
        email: "principale1973@gmail.com"
    },
    {
        sno: 50,
        jnbId: "30102",
        name: "Narayana Degree College",
        place: "Kosigi",
        district: "Kurnool",
        phone: "9603309542",
        email: "ndc.kosigi@gmail.com"
    },
    {
        sno: 51,
        jnbId: "30503",
        name: "RC Reddy Degree College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "8008611688",
        email: "rcreddy_2024@yahoo.com"
    },
    {
        sno: 52,
        jnbId: "30562",
        name: "Sri Vyshnavi Degree College",
        place: "Pathikonda",
        district: "Kurnool",
        phone: "8099956903",
        email: "srivyshnavidegreecollegepkd@gmail.com"
    },
    {
        sno: 53,
        jnbId: "30500",
        name: "Sri Vyshnavi Degree College",
        place: "Nandikotkur",
        district: "Nandyal",
        phone: "9390208187",
        email: "srivyshnavidegreecollege@gmail.com"
    },
    {
        sno: 54,
        jnbId: "30501",
        name: "Pragna Degree College",
        place: "Allagadda",
        district: "Nandyal",
        phone: "9948813593",
        email: "degreecollegepragna@gmail.com"
    },
    {
        sno: 55,
        jnbId: "30502",
        name: "Sri Sai Venkateswara Degree College",
        place: "Gudur",
        district: "Kurnool",
        phone: "8885182900",
        email: "jyothisrisai12@gmail.com"
    },
    {
        sno: 56,
        jnbId: "30534",
        name: "Sri Raghavendra Degree College",
        place: "Pathikonda",
        district: "Kurnool",
        phone: "9703996441",
        email: "pmasumbasha@gmail.com"
    },
    {
        sno: 57,
        jnbId: "30598",
        name: "Anantha Degree College",
        place: "Allagadda",
        district: "Nandyal",
        phone: "9440112882",
        email: "principalananthadegree@gmail.com"
    },
    {
        sno: 58,
        jnbId: "30507",
        name: "Sai Sree Mahila Degree College",
        place: "Dhone",
        district: "Nandyal",
        phone: "7901382904",
        email: "ssmdc.dhone@gmail.com"
    },
    {
        sno: 59,
        jnbId: "31486",
        name: "Sri Venkateswara College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "9985441484",
        email: "svdcms@gmail.com"
    },
    {
        sno: 60,
        jnbId: "31457",
        name: "Sri Raghavendra Degree College",
        place: "Mantralayam",
        district: "Kurnool",
        phone: "8331949587",
        email: "vsrayudu414@gmail.com"
    },
    {
        sno: 61,
        jnbId: "31497",
        name: "Sree Venkateswara Degree College",
        place: "Devenakonda",
        district: "Kurnool",
        phone: "9553645145",
        email: "svdcdk2017@gmail.com"
    },
    {
        sno: 62,
        jnbId: "31502",
        name: "Thanuja Memorial Degree College",
        place: "Holagunda",
        district: "Kurnool",
        phone: "8919986647",
        email: "tssreddy1964@gmail.com"
    },
    {
        sno: 63,
        jnbId: "31524",
        name: "Vignan Degree College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "9949204720",
        email: "mullangimr@gmail.com"
    },
    {
        sno: 64,
        jnbId: "31519",
        name: "Keerthi Degree College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "9989325944",
        email: "ynr.anantha@gmail.com"
    },
    {
        sno: 65,
        jnbId: "31795",
        name: "Rao’s Degree College",
        place: "Nandyal",
        district: "Nandyal",
        phone: "7981995531",
        email: "ndl.rjc@gmail.com"
    },
    {
        sno: 66,
        jnbId: "31681",
        name: "Karthikeya Degree College",
        place: "Kowthalam",
        district: "Kurnool",
        phone: "9985259891",
        email: "kdc.kowthalam@gmail.com"
    },
    {
        sno: 67,
        jnbId: "31720",
        name: "Sumourya Degree College",
        place: "Holagunda",
        district: "Kurnool",
        phone: "9246922259",
        email: "sumouryaedu@gmail.com"
    },
    {
        sno: 68,
        jnbId: "16825",
        name: "Rao’s Degree College",
        place: "Yemmiganur",
        district: "Kurnool",
        phone: "7799912659",
        email: "raosdc022@gmail.com"
    },
    {
        sno: 69,
        jnbId: "20129",
        name: "SV Arts & Commerce Degree College",
        place: "Chagalamarri",
        district: "Nandyal",
        phone: "9441294432",
        email: "svacscmi1981@gmail.com"
    },
    {
        sno: 70,
        jnbId: "18132",
        name: "SNSR Degree College",
        place: "Velgode",
        district: "Nandyal",
        phone: "8121137392",
        email: "snsrcollege@gmail.com"
    }
    ,

    {
        sno: 71,
        jnbId: "14706",
        name: "Kurnool Degree College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9246920001",
        email: "kdcknl@ymail.com"
    },
    {
        sno: 72,
        jnbId: "46446",
        name: "Sri Sujayendra Degree College",
        place: "Mantralayam",
        district: "Kurnool",
        phone: "9642380892",
        email: "ravi.sudhi85@gmail.com"
    },
    {
        sno: 73,
        jnbId: "26922",
        name: "Nandanam Degree College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9182163506",
        email: "nandanamdegreecollege@gmail.com"
    },
    {
        sno: 74,
        jnbId: "31809",
        name: "Islamia Arabic College",
        place: "Kurnool",
        district: "Kurnool",
        phone: "9849667880",
        email: "islamiaharabicdegreecollege@gmail.com"
    }
];
